import { FieldHtmlNameUtil } from 'www-shared';
import ExternalUtil from '../../../../../ExternalUtil';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import UnifiedSignupStartScreen from '../session-info/UnifiedSignupStartScreen';
import AbstractCheckErrorSignupScreen from './AbstractCheckErrorSignupScreen';
import AntiSpamUtil from '../../../../../util/AntiSpamUtil';

export default class EmailCheck422SignupScreen extends AbstractCheckErrorSignupScreen {
  public screenName: UnifiedSignupScreenName = 'uss-email-check-422';

  public predicate(): boolean {
    const { emailCheckCode } = this.sessionInfo.value;
    if (emailCheckCode !== 422) {
      return false;
    }
    return true;
  }

  public async initListeners({
    partialDiv,
  }: {
    partialDiv: HTMLElement
  }): Promise<void> {
    if (this.sessionInfo.value.startScreen.compareTo(UnifiedSignupStartScreen.buyStandard)) {
      partialDiv.classList.add('d-none');
      ExternalUtil.redirectTo({ delay: 0, target: this.getField(FieldHtmlNameUtil.signupRedirectUrl).val as string });
      return;
    }

    AntiSpamUtil.csrfTokenTest({ hint: 'signup-422-screen' });
  }
}
